module.exports = __webpack_public_path__ + "static/media/cpu.e727195e.jpg";